module.exports = __webpack_public_path__ + "ed8b0507c6eebb6254a1de86830401d0.jpg";